import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initJQueryPluginsAfterMount } from './assets/utils/comm/initJQueryPlugins';
import { Buffer } from 'buffer';
// ThemeApply 모듈을 로드하여 window.ThemeApply로 노출
import './assets/utils/theme/themeApply';
// ThemeConfig를 직접 import하여 초기화
import { ThemeConfig } from './assets/utils/theme/themeConfig';
// SidebarCommon 모듈을 로드하여 window.sidebarCommon으로 노출
import './assets/utils/sidebar/sidebarCommon';

// ResizeObserver loop 에러 무시는 public/index.html 인라인 스크립트에서 처리 (번들 로드 전 등록)

// @react-pdf/renderer(브라우저)에서 이미지/자산 처리 중 Buffer를 참조합니다.
// CRA(Webpack5)는 Node 폴리필을 자동 제공하지 않으므로 전역 Buffer를 주입합니다.
if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer;
}

// React 앱 렌더링 전에 테마 설정을 DB에서 로드
async function initializeApp() {
  try {
    // ThemeConfig 초기화 (DB에서 테마 설정 로드)
    // 이미 초기화되었으면 기존 Promise 반환 (중복 방지)
    await ThemeConfig.initialize();

    // ThemeApply 초기화 (CSS 변수 및 클래스 적용)
    // 단, ThemeConfig.initialize()는 이미 호출되었으므로 init() 내부의 중복 호출은 기존 Promise를 반환함
    if (typeof window !== 'undefined' && window.ThemeApply) {
      if (!window.__themeApplyInitialized) {
        // ThemeApply.init()은 내부에서 ThemeConfig.initialize()를 다시 호출하지만,
        // 이미 초기화되었으므로 즉시 완료됨
        await window.ThemeApply.init();
        window.__themeApplyInitialized = true;
      }
    }
  } catch (error) {
    console.error('[App] 테마 초기화 중 오류 발생:', error);
    // 오류가 발생해도 앱은 계속 실행
  }

  // React 앱 렌더링 (이 시점에 window.__themeConfig가 이미 설정되어 있음)
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <App />
  );

  // React 렌더링 완료 후 jQuery 플러그인 초기화
  initJQueryPluginsAfterMount();
}

// 앱 초기화 시작
initializeApp();

